<template>
  <footer class="footer">
    <el-container>
      <el-main class="footer-content">
        <!-- Main Footer Grid -->
        <el-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="footer-grid" justify="center">
          <!-- Brand Section -->
          <el-col :xs="24" :sm="24" :md="24" :lg="6" class="footer-section brand-section">
            <div class="brand-wrapper" @click="navigateTo('/')" style="cursor: pointer">
              <el-image
                :src="footerData.brand.logo"
                :fit="'contain'"
                class="brand-logo"
                style="width: 65px; height: 65px"
              />
              <h2 class="brand-title">{{ $t(footerData.brand.name) }}</h2>
            </div>
            <p class="brand-description">{{ footerData.brand.description }}</p>
          </el-col>

          <!-- Dynamic Link Sections -->
          <el-col
            v-for="section in footerData.linkSections"
            :key="section.id"
            :xs="12"
            :sm="12"
            :md="8"
            :lg="section.colSize || 4"
            class="footer-section link-section"
          >
            <h3 class="section-title">{{ $t(section.title) }}</h3>
            <ul class="link-list">
              <li v-for="link in section.links" :key="link.id || link.text">
                <el-link
                  @click="handleLinkClick(link)"
                  :underline="false"
                  class="footer-link"
                >
                  {{ $t(link.text || link.title || link.name) }}
                </el-link>
              </li>
            </ul>
          </el-col>

          <!-- Social & Apps Section -->
          <el-col :xs="24" :sm="24" :md="12" :lg="6" class="footer-section social-section">
            <!-- App Downloads -->
            <div class="app-downloads">
              <el-link
                v-for="app in footerData.appStores"
                :key="app.name"
                :href="app.url"
                target="_blank"
                :underline="false"
                class="app-link"
              >
                <el-image
                  :src="app.image"
                  fit="contain"
                  class="app-image"
                  :alt="app.name"
                />
              </el-link>
            </div>

            <!-- Social Media -->
            <div class="social-links">
              <el-link
                v-for="social in footerData.socialMedia"
                :key="social.name"
                :href="social.url"
                target="_blank"
                :underline="false"
                class="social-link"
              >
                <el-image
                  :src="social.icon"
                  fit="contain"
                  class="social-icon"
                  :alt="social.name"
                />
              </el-link>
            </div>
          </el-col>
        </el-row>

        <!-- Footer Bottom -->
        <el-divider />
        <div class="footer-bottom">
          <p class="copyright">
            {{ $t(footerData.copyright.text) }}
            <span class="brand-highlight">@ {{ $t(footerData.brand.name) }}</span>
          </p>
        </div>
      </el-main>
    </el-container>
  </footer>
</template>

<script>
import crudDataService from "@/Services/crudDataService";
import google from "@/assets/images/pngwing.jpeg";
import app from "@/assets/images/pngw.png";
import exp from "@/assets/images/pngwi.jpg";
import face from "@/assets/icon/face.png";
import twitter from "@/assets/icon/twitter.png";
import insta from "@/assets/icon/insta.png";
import tiktok from "@/assets/icon/tiktok.svg";

export default {
  data() {
    return {
      apiData: {
        appData: null,
        searchOptions: []
      }
    };
  },
  computed: {
    footerData() {
      return {
        brand: {
          name: "Brand",
          logo: this.apiData.appData?.logo || "",
          description: this.apiData.appData?.description || ""
        },
        linkSections: [
          {
            id: "about",
            title: "around",
            colSize: 4,
            links: [
              { text: "privacy", route: "/privacy" },
              { text: "About", route: "/about-us" },
              { text: "Contact", route: "/contact" },
              { text: "Terms", route: "/terms" },
              { text: "Adsconditions", route: "/ads-conditions" },
              { text: "Agreement", route: "/agreement" }
            ]
          },
          {
            id: "services",
            title: "Our_services",
            colSize: 4,
            links: [
              { id: 1, title: "Real_offers", text: "sell", action: "scroll" },
              { id: 2, title: "Real_requests", text: "buy", action: "scroll" },
              { text: "supportive_services", action: "scroll", params: { support: "supportive_services" } },
              { text: "Real_estate", route: "/real-estate" }
            ]
          },
          {
            id: "search",
            title: "Search_options",
            colSize: 4,
            links: this.apiData.searchOptions || []
          }
        ],
        socialMedia: [
          {
            name: "twitter",
            url: this.apiData.appData?.twitter || "#",
            icon: twitter
          },
          {
            name: "instagram", 
            url: this.apiData.appData?.instagram || "#",
            icon: insta
          },
          {
            name: "facebook",
            url: this.apiData.appData?.facebook || "#", 
            icon: face
          },
          {
            name: "tiktok",
            url: this.apiData.appData?.tiktok || "#",
            icon: tiktok,
          }
        ].filter(social => social.show !== false),
        appStores: [
          {
            name: "Google Play",
            url: this.apiData.appData?.google_play || "#",
            image: google
          },
          {
            name: "App Store",
            url: this.apiData.appData?.app_store || "#",
            image: app
          },
          {
            name: "Huawei Store", 
            url: this.apiData.appData?.huawei_store || "#",
            image: exp
          }
        ],
        copyright: {
          text: "all_rights"
        }
      };
    }
  },
  methods: {
    handleLinkClick(link) {
      if (link.route) {
        this.navigateTo(link.route);
      } else if (link.action === "scroll") {
        this.scrollToSection("target-section", link.estate_type_id, link.ad_type_id, link.params?.support, link.text);
      }
    },
    
    scrollToSection(sectionId, estate_type, ad_type, support, param) {
      this.$router.push({
        path: "/",
        query: {
          estate_type: estate_type || "",
          ad_type: ad_type || "",
          support: support || "",
          param: param || ""
        }
      });
      this.$nextTick(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      });
    },

    navigateTo(route) {
      this.$router.push(route);
    },
    
    async loadAppData() {
      try {
        const response = await crudDataService.getAll("application-data");
        this.apiData.appData = response.data.data;
      } catch (error) {
        console.error("Failed to load app data:", error);
      }
    },
    
    async loadSearchOptions() {
      try {
        const response = await crudDataService.getAll("types");
        this.apiData.searchOptions = response.data.data.slice(0, 8).map(item => ({
          ...item,
          action: "scroll"
        }));
      } catch (error) {
        console.error("Failed to load search options:", error);
      }
    }
  },
  
  async mounted() {
    await Promise.all([
      this.loadAppData(),
      this.loadSearchOptions()
    ]);
  }
};
</script>
<style lang="scss" scoped>
.footer {
  background: #1f2937;
  color: white;
  margin-top: 4rem;
  padding-top: 4rem; // Added top padding

  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1.5rem 1.5rem;

    .footer-grid {
      margin-bottom: 2rem;
    }
  }

  // Footer Sections
  .footer-section {
    margin-bottom: 2.5rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

  }

  // Brand Section
  .brand-section {
    .brand-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1.5rem;
      transition: opacity 0.3s ease;

      

      &:hover {
        opacity: 0.8;
      }

      .brand-logo {
        margin-right: 1rem;
        filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
      }

      .brand-title {
        color: white;
        font-size: 1.75rem; // Increased size for brand
        font-weight: 700;
        margin: 0;
        text-transform: uppercase;
        letter-spacing: 1px;
        background: linear-gradient(135deg, #ffffff, #0074c7);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
    }

    .brand-description {
      font-size: 1rem;
      line-height: 1.6;
      color: #d1d5db;
      margin: 0;
      max-width: 100%;
      text-align: center;
      padding: 0 1rem;

    }
  }

  // Link Sections
  .link-section {
    .section-title {
      color: white;
      font-size: 1.375rem; // Increased font size
      font-weight: 700;
      text-align: center;
      margin-bottom: 1.5rem;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      position: relative;
      padding-bottom: 0.75rem;
      
      // Professional underline effect
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 40px;
        height: 3px;
        background: linear-gradient(90deg, #0074c7, #f6c712);
        border-radius: 2px;
        
        @media (min-width: 1024px) {
          left: 0;
          transform: none;
        }
      }
    }

    .link-list {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

     

      li {
        margin-bottom: 0.875rem;
        width: 100%;
        display: flex;
        justify-content: center;

       
      }
    }

    .footer-link {
      color: #d1d5db !important;
      font-size: 1rem;
      font-weight: 400;
      transition: all 0.3s ease;
      cursor: pointer;
      padding: 0.25rem 0.5rem;
      border-radius: 4px;
      position: relative;

      &:hover {
        color: #0074c7 !important;
        background: rgba(246, 199, 18, 0.1);
        transform: translateX(4px);
      }
    }
  }

  // Social Section
  .social-section {
    .app-downloads {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      margin-bottom: 2.5rem;

      @media (min-width: 768px) {
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
      }

    

      .app-link {
        display: block;
        width: 150px;
        transition: transform 0.3s ease;

        @media (max-width: 767px) {
          width: 130px;
        }

        &:hover {
          transform: scale(1.05);
        }

        .app-image {
          width: 100%;
          height: auto;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
          transition: all 0.3s ease;

          &:hover {
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
          }
        }
      }
    }

    .social-links {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;

      @media (min-width: 1024px) {
        justify-content: flex-start;
      }

      .social-link {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 48px !important;
        height: 48px !important;
        background: rgba(255, 255, 255, 0.1) !important;
        border-radius: 50% !important;
        transition: all 0.3s ease !important;
        text-decoration: none !important;
        position: relative;
        overflow: hidden;

        @media (max-width: 767px) {
          width: 44px !important;
          height: 44px !important;
        }

        // Gradient border effect
      

        &:hover {
          background-color: #f3f3f3 !important;
          color: white !important;
          transform: translateY(-3px);
        }

        .social-icon {
         color: white;
         transition: all 0.3s ease;
         font-size: 20px;
         display: block;
         margin: auto;
         width: 20px;
         height: 20px;
        }

        &:hover .social-icon {
          color: white;
          transform: scale(1.1);
        }
      }
    }
  }

  // Footer Bottom
  .footer-bottom {
    text-align: center;
    padding: 2rem 0;

    .copyright {
      color: #9ca3af;
      font-size: 0.875rem;
      margin: 0;
      font-weight: 400;

      .brand-highlight {
        color: #0074c7;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }
  }

  // Element Plus Overrides
  :deep(.el-container) {
    background: transparent;
  }

  :deep(.el-main) {
    padding: 0;
  }

  :deep(.el-divider) {
    border-color: rgba(255, 255, 255, 0.1);
    margin: 2rem 0;
  }

  :deep(.el-link) {
    font-weight: normal;
  }

  :deep(.el-row) {
    margin: 0 !important;
  }

  :deep(.el-col) {
    padding: 0 !important;
  }

  // Responsive spacing
  @media (max-width: 767px) {
    .footer-content {
      padding: 0 1rem 1rem;
    }

    .footer-section {
      margin-bottom: 2rem;
      
      &:last-child {
        margin-bottom: 0;
      }
    }

    .brand-section {
      .brand-wrapper .brand-title {
        font-size: 1.5rem;
      }
      
      .brand-description {
        font-size: 0.875rem;
      }
    }

    .link-section {
      .section-title {
        font-size: 1.25rem;
        margin-bottom: 1.25rem;
        
        &::after {
          width: 30px;
          height: 2px;
        }
      }

      .footer-link {
        font-size: 0.9rem;
        
        &:hover {
          transform: translateX(2px);
        }
      }
    }

    .footer-bottom {
      .copyright {
        font-size: 0.75rem;
      }
    }
  }

  @media (max-width: 480px) {
    .footer-content {
      padding: 0 0.75rem 1rem;
    }

    .brand-section {
      .brand-wrapper .brand-title {
        font-size: 1.375rem;
      }
    }

    .link-section {
      .section-title {
        font-size: 1.125rem;
        
        &::after {
          width: 25px;
        }
      }
    }

    .social-section {
      .app-downloads .app-link {
        width: 110px;
      }

      .social-links {
        gap: 0.75rem;
        
        .social-link {
          width: 40px !important;
          height: 40px !important;
          
          .social-icon {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
